/**
 * Pass a JSON and it will convert its array value into one array hence the word "flatten"
 */

export default function (json) {
  const result = [];

  for (const key in json) {
    if (json.hasOwnProperty(key)) {
      result.push(...json[key]);
    }
  }

  return result;
}
